const handleHeroVideo = () => {
  const selectors = {
    video: '.js-hero-video video',
    content: '.js-content',
  };

  const state = {
    active: 'is-active',
  };

  const video = document.querySelector(selectors.video);

  if (!video) return;

  const content = document.querySelector(selectors.content);

  // start counting when video is loaded
  video.addEventListener('canplay', () => {
    setTimeout(() => {
      content.classList.add(state.active);
    }, video.duration * 1000); // Count for video duration to start text animation(in seconds)
  });
};

export default handleHeroVideo;
